import XSelect from "../common/XSelect";

const wrapDefaultClasses = "w-80";
const labelClasses = "block mb-1 text-xs font-semibold text-content";
const headerSelectClasses = "h-10 py-1 px-2 text-sm min-w-[10rem] max-w-[16rem]";
const defaultSelectClasses = "text-sm";

const DemandStudioPreviewClientSelect = ({
  options,
  selectedClientId,
  onSelectClient,
  variant = "default",
}) => {
  if (!options || options.length <= 1) return null;
  const isHeaderVariant = variant === "header";
  const handleChange = (event) => onSelectClient({ value: event.target.value });

  // header variant matches the sibling demand-type select for a consistent look
  if (isHeaderVariant) {
    return (
      <XSelect
        id="demand-studio-lifecare-client-select"
        aria-label="Select client"
        className={headerSelectClasses}
        value={selectedClientId}
        onChange={handleChange}
        options={options}
        emptyOption={false}
      />
    );
  }

  return (
    <div className={wrapDefaultClasses}>
      <label htmlFor="demand-studio-lifecare-client-select" className={labelClasses}>
        Select client
      </label>
      <XSelect
        id="demand-studio-lifecare-client-select"
        aria-label="Select client"
        className={defaultSelectClasses}
        value={selectedClientId}
        onChange={handleChange}
        options={options}
        emptyOption={false}
      />
    </div>
  );
};

export default DemandStudioPreviewClientSelect;
